'use strict';

/* global jQuery yith yithStripePayments */

import OnboardingWidget from './modules/OnboardingWidget';
import OnboardingButton from './modules/OnboardingButton';

// init onboarding process.
jQuery( ( $ ) => {
	const $onboardingWidget = $( '.yith-stripe-payments__onboarding' ),
		$envRadio = $( ':input[id*="environment"]' );

	// start onboarding widget JS behaviour.
	$onboardingWidget.length && new OnboardingWidget( $onboardingWidget );

	window.yithStripePayments.connectOnboarding = function (
		button,
		options = {}
	) {
		const $button = $( button );

		if ( ! $button.length ) {
			return;
		}

		return new OnboardingButton( $button, options );
	};

	// reloads page when environment option is changed. Double $( fn ) is required to run this code after WC's one, that does the same.
	// @see wp-content/plugins/woocommerce/assets/js/admin/settings.js:93
	$( () => {
		$envRadio.on( 'change', ( ev ) => {
			window.onbeforeunload = null;

			$( ev.target ).closest( 'form' ).submit();

			return false;
		} );
	} );
} );
